import uniqueId from "lodash.uniqueid";
import { compose, withState, mapProps, setDisplayName } from "recompose";
import omit from "ramda/es/omit";
import merge from "ramda/es/merge";
import { cloneElement, createElement, isValidElement } from "react";
var generateIntId = function generateIntId() {
    return uniqueId();
  },
  withUniqueId = function withUniqueId(e) {
    return function (n) {
      var t = merge({
          prefix: "",
          generateId: generateIntId
        }, e),
        i = t.prefix,
        r = t.generateId;
      return compose(setDisplayName("WithUniqueId"), withState("id", "setId", function (e) {
        return "" + (e.prefix || i) + r();
      }), mapProps(omit(["setId", "prefix"])))(n);
    };
  },
  UniqueId = function UniqueId(e) {
    var n = e.id,
      t = omit(["component", "render"])(e);
    return null != e.render ? e.render(Object.assign({}, t, {
      id: n
    })) : !0 === isValidElement(e.component) ? cloneElement(e.component, {
      id: n
    }) : createElement(e.component, Object.assign({}, t, {
      id: n
    }));
  },
  enhance = compose(setDisplayName("UniqueId"), withUniqueId({})),
  UniqueId$1 = enhance(UniqueId);
export default UniqueId$1;
export { withUniqueId };